// extracted by mini-css-extract-plugin
export default {"main":"ac95edc515 d8905a61d5","xmark":"_69b540152a","fl_img":"_2921ef08ec d6591d27ad"};